// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostBodyMessageRequests-modulemultiValuedList__CPthx MultiValuedList-moduleMultiValuedList__ZJwbV";
var _2 = "NewsboardPostBodyMessageRequests-modulerequest__NjztR";
export { _1 as "multiValuedList", _2 as "request" }
